export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13250.f62272bf.jpg";